
// @ts-ignore
import {translate} from '@elements/translations';
import { defineComponent } from "vue";

export default defineComponent({
    name: 'LoadingSpinner',
    props: {
        loading: {
            type: Boolean,
            required: true,
        }
    },
    setup() {
        return {
            translate
        };
    }
});
